module.exports = __webpack_public_path__ + "img/integralShop_coupon_bg.1d2eb938.png";